import React, { FC } from 'react';
import { Grid2 as Grid, IconButton, Typography } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { Link as RouterLink } from 'react-router-dom';
import { Revision } from './Details';
import { StyledPaper } from '../theme';
import { CheckItemList } from './ChecklistTasks';
import { checklistTitle } from './checklistTemplateModel';
import { useCanEditChecklists } from './useCanEditChecklists';

export const CheckItems: FC<{ revision: Revision; history: boolean }> = ({ revision, history }) => {
  const canEditChecklists = useCanEditChecklists();
  const items = (revision?.checklist?.checkItems ?? []).filter((x) => !!x);

  if (items.length === 0) return null;

  return (
    <StyledPaper>
      <Grid container justifyContent="space-between">
        <Grid>
          <Typography variant="h5" component="h3">
            {checklistTitle}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {items.filter((item) => item.checked).length}/{items.length} utført
          </Typography>
        </Grid>
        {canEditChecklists && (
          <Grid>
            <IconButton
              component={RouterLink}
              to={`/checklist-template?type=${revision?.type}&section=checklist&revision=${revision?.id}`}
              title={`Tilpass malen for ${checklistTitle.toLowerCase()}`}
              size="small">
              <SettingsIcon fontSize="small" />
            </IconButton>
          </Grid>
        )}
      </Grid>
      <CheckItemList revisionId={revision?.id} items={items} history={history} />
    </StyledPaper>
  );
};
